import { useCallback } from 'react'
import { translations } from '@/lib/translations'
import { useLanguage } from '@/context/language-context'

export const useTranslation = () => {
  const { language } = useLanguage()
  const t = useCallback(
    (key: string) => translations[language][key] ?? key,
    [language]
  )
  return { t }
}
